import { put } from 'redux-saga/effects';
import actions from '../../../../actions';
import acceptOlbTermsFetch from '../../../api/acceptOlbTerms';

function* acceptOlbTerms(userId) {
  const response = yield acceptOlbTermsFetch(userId);
  yield put(actions.acceptOlbTermsSuccess(response));
}
export default acceptOlbTerms;
